import {
  LineBasicMaterial,
  LineDashedMaterial,
  Material,
  MeshBasicMaterial,
  MeshDistanceMaterial,
  MeshLambertMaterial,
  MeshMatcapMaterial,
  MeshNormalMaterial,
  MeshPhongMaterial,
  MeshPhysicalMaterial,
  MeshStandardMaterial,
  MeshToonMaterial,
  PointsMaterial,
  RawShaderMaterial,
  ShaderMaterial,
  ShadowMaterial,
  SpriteMaterial,
} from 'three';

export interface ThreeJsMaterial {
  /**
   * Preserve color of the original QModel primitive?
   */
  preserveColor: boolean;
  materialType: string;
  parameters: string;
}

export function createThreeJsMaterial(material: ThreeJsMaterial): Material {
  switch (material.materialType) {
    case 'LineBasicMaterial':
      return new LineBasicMaterial(JSON.parse(material.parameters));
    case 'LineDashedMaterial':
      return new LineDashedMaterial(JSON.parse(material.parameters));
    case 'MeshDistanceMaterial':
      return new MeshDistanceMaterial(JSON.parse(material.parameters));
    case 'MeshLambertMaterial':
      return new MeshLambertMaterial(JSON.parse(material.parameters));
    case 'MeshMatcapMaterial':
      return new MeshMatcapMaterial(JSON.parse(material.parameters));
    case 'MeshNormalMaterial':
      return new MeshNormalMaterial(JSON.parse(material.parameters));
    case 'MeshPhongMaterial':
      return new MeshPhongMaterial(JSON.parse(material.parameters));
    case 'MeshPhysicalMaterial':
      return new MeshPhysicalMaterial(JSON.parse(material.parameters));
    case 'MeshStandardMaterial':
      return new MeshStandardMaterial(JSON.parse(material.parameters));
    case 'MeshBasicMaterial':
      return new MeshBasicMaterial(JSON.parse(material.parameters));
    case 'MeshToonMaterial':
      return new MeshToonMaterial(JSON.parse(material.parameters));
    case 'PointsMaterial':
      return new PointsMaterial(JSON.parse(material.parameters));
    case 'RawShaderMaterial':
      return new RawShaderMaterial(JSON.parse(material.parameters));
    case 'ShaderMaterial':
      return new ShaderMaterial(JSON.parse(material.parameters));
    case 'ShadowMaterial':
      return new ShadowMaterial(JSON.parse(material.parameters));
    case 'SpriteMaterial':
      return new SpriteMaterial(JSON.parse(material.parameters));
  }
  throw new Error(`Material type ${material.materialType} is not supported`);
}
